var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjktSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.249,
    height: 11.878,
    viewBox: "0 0 31.249 11.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 31.249,
    height: 10.693,
    fill: "#3c3c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "objkt_small",
    transform: "translate(0 1.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M14.074,7.9c-.23.945-.96.42-1.549.611V.023h1.744V2.915A6.586,6.586,0,0,1,15.729,2.5,2.006,2.006,0,0,1,17.9,4.19a6.937,6.937,0,0,1-.038,2.649A2.274,2.274,0,0,1,14.074,7.9m2.3-2.432a2.656,2.656,0,0,0-.255-1,1.485,1.485,0,0,0-.98-.641c-.26,0-.658.46-.747.784a4.757,4.757,0,0,0-.062,1.583c.041.54.257,1.027.914,1.024s.918-.47,1.04-1.036c.043-.2.052-.4.09-.711",
    transform: "translate(-5.764 -0.011)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M36.319,0h1.76V4.3c1.118-1,1.883-2.434,3.588-1.556l-2.2,1.983,2.554,3.585c-1.287.4-1.782.246-2.506-.772-.366-.514-.731-1.029-1.172-1.651-.5.871-.1,1.719-.344,2.521H36.319Z",
    transform: "translate(-16.714 0)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M5.865,7.659A2.851,2.851,0,0,1,2.9,10.608,2.864,2.864,0,0,1,0,7.575a3.005,3.005,0,0,1,2.98-3A2.983,2.983,0,0,1,5.865,7.659m-1.665,0a5.814,5.814,0,0,0-.291-1.03A1.039,1.039,0,0,0,2.044,6.5,2.365,2.365,0,0,0,2.09,8.769a1.015,1.015,0,0,0,1.693-.017A5.534,5.534,0,0,0,4.2,7.662",
    transform: "translate(0 -2.103)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M23.977,11.986l.927-1.238a3.66,3.66,0,0,0,.927.7.626.626,0,0,0,.91-.614c.014-.256.034-.513.035-.769,0-1.254,0-2.508,0-3.831H24.819V4.9h3.72c0,2.035.057,4.083-.027,6.125A1.983,1.983,0,0,1,27,12.794a2.843,2.843,0,0,1-3.021-.808",
    transform: "translate(-11.034 -2.255)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M49.551,3.318l.123-1.353,1.794-.259-.124,1.645H53.1v1.38H51.283c0,.846-.053,1.652.018,2.447.052.585.48.826,1.063.666.288-.079.561-.209.838-.315.5,1.106.438,1.246-.641,1.612-1.773.6-2.971-.179-3.075-2.036-.043-.762-.007-1.528-.007-2.326l-1.124-.089V3.412l1.2-.093",
    transform: "translate(-22.253 -0.786)",
    fill: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(15.06 -1.185)",
    fill: "#3c3c3c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjktSmall);
export default __webpack_public_path__ + "static/media/objkt_small.4903d681.svg";
export { ForwardRef as ReactComponent };